import React, { useEffect, useState } from 'react';
import { Mail, Linkedin, FileText } from 'lucide-react';
import { fetchContact, fileUrl } from '../lib/api';

export default function Footer() {
  const year = new Date().getFullYear();
  const [contact, setContact] = useState({ email: '', linkedin: '', portfolio_filename: '' });

  useEffect(() => {
    fetchContact().then(setContact).catch(() => {});
    const onUpdate = (e) => setContact(e.detail);
    window.addEventListener('contact-updated', onUpdate);
    return () => window.removeEventListener('contact-updated', onUpdate);
  }, []);

  const links = [
    contact.portfolio_filename && { key: 'portfolio', href: fileUrl(contact.portfolio_filename), icon: FileText, label: 'Resume (PDF)', external: true, text: 'RESUME' },
    contact.email && { key: 'email', href: `mailto:${contact.email}`, icon: Mail, label: 'Email' },
    contact.linkedin && { key: 'linkedin', href: contact.linkedin, icon: Linkedin, label: 'LinkedIn', external: true }
  ].filter(Boolean);

  return (
    <footer className="relative z-40 border-t border-[#3a2512] bg-[#0a0502]">
      <div className="w-full px-4 md:px-6 py-3 flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <div className="font-display text-lg text-[#ffe9b8] chroma tv-blink leading-none relative -top-1">OWEN DILLEY</div>
        <div className="font-osd text-[11px] tracking-widest text-[#8b6a3e]">
          &copy; {year} BROADCASTING SERVICE &middot; END OF TRANSMISSION
        </div>
        <div className="flex gap-2 relative -top-1 min-w-[1px]">
          {links.map(({ key, href, icon: Icon, label, external, text }) => (
            <a
              key={key}
              href={href}
              aria-label={label}
              title={label}
              data-testid={`footer-link-${key}`}
              {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className={`header-tab h-9 border-2 rounded-sm flex items-center justify-center gap-1.5 ${text ? 'px-2.5' : 'w-9'}`}
            >
              <Icon className="w-4 h-4" />
              {text && <span className="font-osd text-[11px] tracking-widest">{text}</span>}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
